import { FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import { useForgotPasswordMutation } from "@/store/api";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Alert } from "@/components/ui/alert";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [forgot, { isLoading }] = useForgotPasswordMutation();

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      await forgot({ email }).unwrap();
    } catch {
      // Backend always 200s; if we get here it's network — still treat as
      // submitted to avoid revealing whether the email is registered.
    }
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen grid place-items-center bg-bg text-fg p-4">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle>Reset your password</CardTitle>
          <CardDescription>
            Enter the email you signed up with — we'll send a reset link.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {submitted ? (
            <Alert tone="info">
              If that email is registered, a password-reset link is on the way.
              The link expires in 1 hour. Check your spam folder.
              <div className="pt-3 text-xs">
                <Link to="/login" className="text-accent underline">Back to sign in</Link>
              </div>
            </Alert>
          ) : (
            <form onSubmit={onSubmit} className="space-y-3">
              <Input
                type="email"
                placeholder="you@example.com"
                autoFocus
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Button
                type="submit"
                variant="primary"
                size="lg"
                className="w-full"
                disabled={isLoading || !email}
              >
                {isLoading ? "Sending…" : "Send reset link"}
              </Button>
              <p className="text-xs text-muted text-center">
                <Link to="/login" className="text-accent underline">Back to sign in</Link>
              </p>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
